import '../../../../../assets/vendor/swiper/swiper-bundle.js';
import Video from './video';

export default class HeaderWidthNavigation {
    constructor($slider) {
        this.$slider = $slider;
        this.$videos = this.$slider.querySelectorAll('video')

        this.$swiper = new Swiper(this.$slider, {
            slidesPerView: 1,
            autoHeight: true,
            loop: false,
            speed: 500,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });

        this.$swiper.on('slideChange', function (swiper) {
            const $currentSlideVideo = swiper.slides[swiper.activeIndex].querySelector('[data-video]');
            const $prevSlideVideo = swiper.slides[swiper.previousIndex].querySelector('[data-video]');

            if($currentSlideVideo) {
                (new Video($currentSlideVideo)).play();
            }

            if($prevSlideVideo) {
                (new Video($prevSlideVideo)).pause();
            }
        });

        this.$videos.forEach($video => {
            $video.addEventListener('loadeddata', () => {
                this.$swiper.updateAutoHeight(0);
            },false);
        })
    }
}